import api from 'axios'
let moment = require('moment')

const state = {
  unpaidExpenses: null,
  upcomingExpenses: null,
  ledgerStats: null
}

const actions = {
  getUnpaidExpenses ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.get('/dashboard/unpaid-expenses/' + moment().format('YYYY-MM-DD'))
        .then(
          response => {
            commit('SET_UNPAID_EXPENSES', response.data.unpaidExpenses)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  getUpcomingExpenses ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.get('/dashboard/upcoming-expenses/' + moment().format('YYYY-MM-DD'))
        .then(
          response => {
            commit('SET_UPCOMING_EXPENSES', response.data.expenses)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  },
  getLedgerStats ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.get('/dashboard/ledger-stats/' + moment().format('YYYY-MM-DD'))
        .then(
          response => {
            commit('SET_LEDGER_STATS', response.data.ledgerStats)
            resolve(response.data)
          }
        )
        .catch(
          error => {
            (error.response) ? reject(error.response.data) : reject(error)
          }
        )
    })
  }
}

const mutations = {
  SET_UNPAID_EXPENSES (state, data) {
    state.unpaidExpenses = data
  },
  UNSET_UNPAID_EXPENSES (state, data) {
    state.unpaidExpenses = null
  },
  SET_UPCOMING_EXPENSES (state, data) {
    state.upcomingExpenses = data
  },
  UNSET_UPCOMING_EXPENSES (state, data) {
    state.upcomingExpenses = null
  },
  SET_LEDGER_STATS (state, data) {
    state.ledgerStats = data
  },
  UNSET_LEDGER_STATS (state, data) {
    state.ledgerStats = null
  }
}

export default {
  state,
  actions,
  mutations
}
